export default "__VITE_ASSET__5d16545d__"